import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import s from './AppointmentButton.css';
import cx from 'classnames';


export default class AppointmentButton extends Component {
  static propTypes = {
    handleClick: func,
    disabled: bool,
    isHiddenDesktop: bool,
    text: string,
  };

  constructor(props) {
    super(props);

    this.state = {
      scrollingActive: false,
    };

    this.scrollingTimeout = null;
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    if (!this.state.scrollingActive) {
      this.setState({
        scrollingActive: true
      });
    }

    clearTimeout(this.state.scrollingTimeout);
    this.scrollingTimeout = setTimeout(function() {
      this.setState({
        scrollingActive: false
      });
    }.bind(this), 150);
  }

  render = () => {
    const { isHiddenDesktop } = this.props;
    // If isHiddenDesktop is false, use desktop styles, else use mobile
    const styleRules = (!isHiddenDesktop ? s.component : s.mobile);
    // Boolean prop, if it exists apply display: none;
    const hideForDesktop = (isHiddenDesktop ? s.hide : null);
    // The button needs type submit or button based on where it is located in the dom
    const renderType = (isHiddenDesktop ? 'button' : 'submit');

    return (
      <button
        id={`${this.props.text}__id`}
        ref="apptBtn"
        disabled={this.props.disabled}
        type={renderType}
        onClick={this.props.handleClick}
        className={cx(styleRules, hideForDesktop, {[`${s.scrollHide}`]: this.state.scrollingActive})}
      >
        {this.props.text}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/AppointmentButton/AppointmentButton.js